export enum ActiveContent {
  CenterAndLeft = 1,
  CenterAndRight = 2,
  Center = 3,
}
